import Vue from 'vue'
import moment from 'moment'

Vue.filter('moment', (input, config = 'YYYY-MM-DD HH:mm') => {
  return input ? moment(input).format(config) : ''
})

/**
 * 传入城市 code 数组获取对应的城市名以 ，分隔
 * @param {Array} cityCodes 城市 code 数组
 * @param {Array} openedCities 开城数据
 * @returns {String} citynames 上海市，北京市
*/
Vue.filter('citynames', (cityCodes, openedCities) => {
  let res = ''

  if (!cityCodes.length) {
    return res
  }
  if (cityCodes[0] === 'ALL') {
    return '全国'
  }

  openedCities.forEach((city) => {
    cityCodes.forEach((code) => {
      if (Number(code) === Number(city.adcode)) {
        res += `${city.city}，`
      }
    })
  })
  return res.substr(0, res.length - 1)
})

Vue.filter('getBrandName', (row = {}, brandList = []) => {
  if (row) {
    const tenantId = row.tenantId || row.runTimeSEid || ''
    return (
      (brandList.filter((v) => v.tenantId === tenantId)[0] || {}).tenantName || ''
    )
  }
})
